<template>
    <div>
        <div class="card" v-if="!$store.getters['authStore/fromUSA']">
            <div class="card-header bg-white" v-if="title">
                <h3 class="card-title">
                    <span class="float-right">{{$t('components.shopord.offers.title')}}</span></h3>
            </div>
            <div class="card-body">
                <router-link :to="resolveRoute('app.shopord')" class="text-wellis-gold">
                    {{$t('components.shopord.showAllSpas')}}
                </router-link>
                <table class="table table-striped table-hover" v-if="offers.length > 0">
                    <thead>
                    <th v-if="btnConfigurator"></th>
                    <th v-if="btnAddCart"></th>
                    <th v-if="name">{{$t('components.stocklist.name') | capitalize}}</th>
                    <th>{{$t('components.shopord.needweek') | capitalize}}</th>
                    <th>{{$t('components.stocklist.configNoShort') | capitalize}}</th>
                    <th>{{$t('components.products.quantity') | capitalize}}</th>
                    <th>{{$t('components.products.price') | capitalize}}</th>
                    <th>{{$t('components.stocklist.acrylicColor') | capitalize}}</th>
                    <th>{{$t('components.stocklist.cabinetColor') | capitalize}}</th>
                    </thead>
                    <tbody>
                    <tr v-for="item in offers" :key="item.uniqueId">
                        <td v-if="btnConfigurator">
                            <a :href="$router.resolve({name: 'app.configurator',
                                                        params: {productIdentifier: item.uniqueId},
                                                        query: {host: 'SHOPORD'}}).href" class="btn btn-sm btn-outline-wellis-black">
                                {{$t('components.stocklist.start-config')}}
                            </a>
                        </td>
                        <td v-if="btnAddCart">
                            <button :id="`offer_${item.uniqueId}`" class="btn btn-sm btn-outline-wellis-black" @click="addCart(item)">
                                {{$t('components.products.availability.btnAddCart')}}
                            </button>
                        </td>
                        <td v-if="name">
                            <router-link class="text-wellis-gold" target="_blank" :to="{name: 'app.shopord.view', query: {uniqueId: item.uniqueId}}">
                                {{item.name | cut}}
                            </router-link>
                        </td>
                        <td>{{$t('components.shopord.readyWeek', {num: item.needWeek})}}</td>
                        <td>
                            <router-link class="text-wellis-gold font-weight-bold" target="_blank" :to="{name: 'app.shopord.view', params: {
                                                                    uniqueId: item.uniqueId}}">
                                {{item.configNo}}
                            </router-link>
                        </td>
                        <td>{{`${item.quantity} ${item.unit}`}}</td>
                        <td class="text-wellis-gold font-weight-bold">
                            <div v-if="hasPrice">
                                <small class="text-black-50 d-block" v-if="item.price.vat">
                                    {{item.price.unitPrice * item.quantity | toPrice(item.price.currency, false)}} + {{$t('components.products.vat')}}
                                </small>
                                {{item.price.unitPrice * item.quantity | toPrice(item.price.currency, item.price.vat)}}
                            </div>
                            <div v-else>
                                -
                            </div>
                        </td>
                        <td>{{item.acrylicColor}}</td>
                        <td>{{item.cabinetColor}}</td>
                    </tr>
                    </tbody>
                </table>
                <div class="row" v-else>
                    <div class="col-sm-12">
                        <p>{{$t('components.products.offers.notfound')}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CartApiService from "@/api/cart.api";
import {EVENT_CART_COUNT_UPDATE} from "@/core/constants";

export default {
    name: "ShopOrdOffers",
    props: {
        offers: Array,
        hasPrice: Boolean,
        catalogNo: String,
        btnConfigurator: Boolean,
        btnAddCart: Boolean,
        acrylicColor: String,
        name: Boolean,
        title: Boolean,
    },

    methods: {
        addCart(item) {
            let loader = this.$loading.show();
            let attributes = {
                "coordinator": "addProductConfiguration",
                "product": item.uniqueId,
                "quantity": item.quantity,
                "host": 'SHOPORD',
                "configurations": {}
            };

            CartApiService.add(attributes)
                .then(response => {
                    this.$eventBus.$emit(EVENT_CART_COUNT_UPDATE, response.data.count);
                    document.getElementById(`offer_${item.uniqueId}`).classList.add('d-none');
                })
                .catch(error => {
                    if (error.response.data.exception) {
                        if (error.response.data.exception.class === 'DifferentWarehouseException') {
                            this.$swal.fire({
                                icon: "error",
                                html: this.$t('components.cart.different-stocklist-warehouse')
                            });
                        }

                        if (error.response.data.exception.class === 'DifferentStocklistTypeException') {
                            this.$swal.fire({
                                icon: "error",
                                html: this.$t('components.cart.different-stocklist-type')
                            });
                        }
                    } else {
                        this.$swal.fire({
                            icon: "error",
                            html: this.$t('components.cart.add-cart-error')
                        });
                    }
                })
                .finally(() => {
                    loader.hide();
                    loader = null;
                });
        }
    },

    computed: {
        resolveRoute() {
            return routeName => {
                if (!this.$store.getters['configStore/getStocklistModuleStatus']) {
                    routeName = 'app.stock-mixed';
                }

                let route = {
                    name: routeName,
                    query: {}
                };

                if (this.catalogNo) {
                    route.query.product = JSON.stringify([this.catalogNo]);
                }

                if (this.acrylicColor) {
                    route.query.characteristics = JSON.stringify({
                        "SZÍNVÁLASZTÉK": [this.acrylicColor]
                    });
                }

                return route;
            }
        },
    }
}
</script>

<style scoped>

</style>
